import React, { useEffect, useRef } from "react";
import { AgCharts } from "ag-charts-community";

/**
 * DashboardMetricsContainer renders a customizable chart using AgCharts.
 *
 * @param {string} title - The title of the chart.
 * @param {Array} data - The data to be displayed in the chart.
 * @param {string} chartType - The type of chart (e.g., "bar", "pie").
 * @param {string} xKey - The key for the x-axis data.
 * @param {string} yKey - The key for the y-axis data.
 * @param {Object} chartOptions - Additional chart configuration options.
 */
export const BarChartContainer = ({ title = "Metrics", data = [], chartType = "bar", xKey = "label", yKey = "count", chartOptions = {}, ...props }) => {
    const chartRef = useRef(null);

    useEffect(() => {
        if (!chartRef.current) return;

        // Define chart options
        const options = {
            container: chartRef.current,
            title: {
                text: title ?? "Metrics",
                fontSize: 16,
            },
            data,
            series: [
                {
                    type: data && data?.length > 0 ? data[0].chartType : chartType,
                    xKey,
                    yKey,
                    fill: '#ffffff',
                    stroke: '#ffffff',
                    ...chartOptions.series, // Allow customization of series options
                },
            ],
            axes: [
                {
                    type: "category",
                    position: "bottom",
                },
                {
                    type: "number",
                    position: "left",
                },
            ],
            background: {
                fill: '#00c8c8',
            },
        };

        // Create the chart
        const chart = AgCharts.create(options);

        // Cleanup on unmount
        return () => {
            chart.destroy();
        };
    }, [title, data, chartType, xKey, yKey, chartOptions]);

    return <div ref={chartRef} style={{ width: "100%", height: "100%" }} />;
};